import { render } from "./banner.vue?vue&type=template&id=96156006"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"
script.render = render

export default script